webpackJsonp([82450655867835],{

/***/ 69:
/***/ (function(module, exports) {

	"use strict";
	/** PYTANIA DO FAQ */
	
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ZAKLADANIE_SPOLEK_PAGE_FAQ_QUESTIONS = [{
	    elementQuestion: "1. Ile trwa założenie spółki zoo?",
	    elementAnswer: "W zależności od regionu Polski, procedura założenia spółki w systemie S24 od jej rozpoczęcia do momentu wpisu w KRS trwa zazwyczaj od 6 do 10 dni roboczych."
	}, {
	    elementQuestion: "2. Czy można otrzymać fakturę za usługę założenia spółki zoo?",
	    elementAnswer: "Tak, za przeprowadzenie rejestracji spółki otrzymują Państwo fakturę VAT."
	}, {
	    elementQuestion: "3. Czy otrzymaną fakturę można wliczyć w koszty?",
	    elementAnswer: "Tak, otrzymaną fakturę można wliczyć w koszty uzyskania przychodu."
	}, {
	    elementQuestion: "4. Kto może być udziałowcem w firmie?",
	    elementAnswer: ["W przypadku mikro sp. z o.o., patrząc z perspektywy uproszczeń rozliczeniowych i podatkowych, najkorzystniejszym przypadkiem jest gdy udziałowcem jest osoba fizyczna.", "Więcej informacji można odleźć również dziale II pkt 1 wpisu na naszej bazie wiedzy."],
	    elementButtonLinkTo: "https://pomoc.fakturomania.pl/support/solutions/articles/36000307874-czym-jest-sp-z-o-o-oraz-jak-j%C4%85-zorganizowa%C4%87-informacje-og%C3%B3lne"
	}, {
	    elementQuestion: "5. Co z ZUS?",
	    elementAnswer: "Wspólnicy spółki z o.o., której struktura właścicielska jest dwu lub ponad dwuosobowa, nie podlegają ZUS. Dany stan rzeczy wynika z braku objęcia obowiązkiem ZUS wspólników w art. 8 ust. 6 ustawy o systemie ubezpieczeń społecznych."
	}, {
	    elementQuestion: "6. Gdzie może być siedziba firmy?",
	    elementAnswer: "Siedzibą spółki jest miejscowość. Siedziba spółki może znajdować się w miejscu  zamieszkania - w domu, w lokalu w mieszkaniu, ale też w przestrzeniach wynajmowanych."
	}, {
	    elementQuestion: "7. Jakie są obowiązki związane z rejestracją spółki z o.o.??",
	    elementAnswer: ["Wraz z rejestracją podmiotu niezbędne jest przygotowanie dokumentacji składanej do Urzędu Skarbowego. Co do zasady są to następujące dokumenty: NIP-8, PCC-3 oraz ewentualnie VAT-R w przypadku rejestracji podmiotu w rejestrze VAT jako \"czynny podatnik VAT\" albo dla celów VATu europejskiego. ", "Niezbędne jest również przygotowanie umowy najmu lokalu oraz zgłoszenie spółki do CRBR."],
	    elementButtonLinkTo: "https://pomoc.fakturomania.pl/support/solutions/articles/36000278880-najem-lokalu-dla-sp%C3%B3%C5%82ki-z-o-o-"
	}];
	exports.CENNIK_PAGE_FAQ_QUESTIONS = [{
	    elementQuestion: "1. Czy możliwe jest przetestowanie aplikacji przed wykupieniem płatnego pakietu?",
	    elementAnswer: "Tak, każdy Użytkownik może skorzystać z bezpłatnego miesięcznego okresu testowego. Oznacza to, że przez miesiąc Użytkownik może bezpłatnie korzystać z pełnej funkcjonalności aplikacji."
	}, {
	    elementQuestion: "2. Co się dzieje po wygaśnięciu okresu testowego?",
	    elementAnswer: "Po wygaśnięciu okresu testowego konto przechodzi w stan spoczynku. Oznacza to, że jego funkcjonalność zostaje zredukowana jedynie do bezpłatnej funkcjonalności, którą jest wystawianie faktur sprzedażowych."
	}, {
	    elementQuestion: "3. Czy płatny pakiet umożliwia samodzielne prowadzenie pełnej księgowości online?",
	    elementAnswer: ["Tak, każdy pakiet premium wystarcza do prowadzenia pełnej księgowości online mikro sp. z o.o. Niniejsze narzędzie umożliwia bardzo łatwe rozliczenie niewielkich podmiotów sp. z o.o. których działąlność występuje na terytorium Rzeczypospolitej o charakterze usługowym lub handlowym", "Ponad 95% Podatników prowadzących swoje rozliczenie w księgowości Fakturomanii to mali podatnicy, których statystyczne rozliczenie oscyluje w granicach do 30 dokumentów w ujęciu miesięcznym. Z tego względu księgowość z Fakturomanią jest optymalizowana właśnie pod kątem takiej wielkości działalności, tak aby każdy mógł w sposób przystępny i prosty rozliczyć taką mikro sp. z o.o.", "System nie jest jednak odpowiedni dla działalności o charakterze produkcyjnym, deweloperskim, transgranicznym lub inwestycyjnym. Z uwagi też na dedykację dla podstawowego obrotu krajowego, w systemie nie są wspierane transakcje o charakterze walutowym lub przynależnym do zysków kapitałowych (np. inwestycje w obrót kryptowalutami, papierami wartościowymi, akcjami, udziałami, zyskami z osób prawnych - przychodów, o których mowa m.in. w art. 7b ustwawy z dnia 15 lutego 1992 o podatku dochodowym od osób prawnych).", "System nie jest również odpowiedni dla podmiotów, które posiadają udziały w innych osobach prawnych lub wspólnikami są osoby prawne, lub w których występują transakcje transgraniczne w tym podlegające procedurze OSS lub IOSS za wyjątkiem sporadycznych transakcji zakupowych WNT lub importu usług. Taki typ działalności warto jest powierzyć prowadzeniu przez biuro rachunkowe z uwagi na jego znaczne skomplikowanie."]
	}, {
	    elementQuestion: "4. Co się dzieje po wygaśnięciu pakietu płatnego?",
	    elementAnswer: "Po wygaśnięciu pakietu płatnego funkcjonalność konta zostaje ograniczona do przeglądania wygenerowanych uprzednio dokumentów oraz konto zamienia się w konto dla bezpłatnej funcjonalności."
	}, {
	    elementQuestion: "5. Czy dla Użytkownika jest możliwość uzyskania pomocy księgowego?",
	    elementAnswer: "W przypadku zdecydowania się na korzystanie z Fakturomanii, w godzinach od 10 do 16, w przypadku pytań lub wątpliwości nasi księgowi są do Państwa dyspozycji. Jeżeli zatem pojawiają się pytania dotyczące aplikacji, księgowości lub spółek zoo - zachęcamy do kontaktu przez czat, mailowo lub telefonicznie, zawsze udzielamy Państwu wsparcia."
	}, {
	    elementQuestion: "6. Czy dostęp do doradcy księgowego zawiera się w pakiecie bezpłatnym?",
	    elementAnswer: "W przypadku pakietu bezpłatnego zespół wsparcia Fakturomanii zawsze udzieli Państwu pomocy z zakresu obsługi technicznej aplikacji."
	}, {
	    elementQuestion: "7. Czy jeśli wykupię dostęp do aplikacji, będę związany umową na czas określony? Czy są jakieś kary umowne lub odsetki?",
	    elementAnswer: "Wykupienie dostępu do aplikacji skutkuje zawiązaniem umowy drogą elektroniczną na czas oznaczony odpowiadający wybranemu pakietowi. Brak jest kar umownych lub odsetek, w każdej chwili mogą Państwo zrezygnować z usług serwisu Fakturomania. W przypadku rezygnacji z serwisu kwota za niewykorzystany czas abonamentu nie podlega jednak zwrotowi."
	}, {
	    elementQuestion: "8. Czy aplikacja Fakturomanii jest skierowana do działalności gospodarczej osób fizycznych?",
	    elementAnswer: ["Aplikacja Fakturomanii jest dedykowana wyłącznie dla osób prawnych - mikro sp. z o.o."]
	}];
	exports.FAQ_PAGE_FAQ_QUESTIONS = [{
	    elementQuestion: "1. Czym jest Fakturomania?",
	    elementAnswer: ["Fakturomania to aplikacja webowa służąca prowadzeniu pełnej księgowości online.", "Nasze rozwiązanie skierowane jest do mikro spółek z ograniczoną odpowiedzialnością prowadzących działalność gospodarczą na terytorium Polski.", "Jeśli chcesz prowadzić własną firmę, ale obawiasz się wysokich kosztów związanych z jej prowadzeniem – Fakturomania może być dobrym rozwiązaniem."]
	}, {
	    elementQuestion: "2. Czym jest pełna księgowość online?",
	    elementAnswer: "Pełna księgowość to rozbudowany, precyzyjny i dokładny system ewidencji zdarzeń gospodarczych, będący częścią Rachunkowości. Służy on do kontroli, analizy i generowania informacji na temat sytuacji firmy w danym momencie lub na przestrzeni pewnego okresu."
	}, {
	    elementQuestion: "3. Czy Fakturomania wymaga specjalistycznej wiedzy księgowej?",
	    elementAnswer: ["Nie, rozliczenia w Fakturomanii nie wymagają posiadania specjalistycznej wiedzy księgowej. Do korzystania z aplikacji wystarczy połączenie z internetem, przeglądarka internetowa, systematyczność oraz skrupulatność.", "Obsługa aplikacji została na tyle uproszczona, aby każdy był w stanie poprowadzić pełną księgowość mikro spółek zoo. W razie jakichkolwiek wątpliwości zawsze służymy pomocą.", "Fakturomania to również bogata baza wiedzy omawiająca zagadnienia związane z księgowością, podatkami i samą spółką z o.o."]
	}, {
	    elementQuestion: "4. Dla kogo przeznaczona jest aplikacja?",
	    elementAnswer: "Aplikacja jest dedykowana jednostkom mikro, które prowadzą działalność w formie spółki z o.o. o profilu usługowym, handlowym lub usługowo-handlowym na terytorium Polski."
	}, {
	    elementQuestion: "5. Ile można zyskać, prowadząc firmę w formie spółki z o.o.?",
	    elementAnswer: ["Dzięki spółce z o.o. zyskać można bardzo wiele, zarówno pod względem znaczącego ograniczenia odpowiedzialności jak i też pod względem oszczędności.", "Kwota oszczędności wynosić może od kilku do nawet kilkudziesięciu tysięcy złotych rocznie - w przypadku optymalnego zaplanowania działaności."]
	}, {
	    elementQuestion: "6. Co z ZUS?",
	    elementAnswer: "W sytuacji gdy wspólników w spółce jest co najmniej dwóch, to żaden z nich nie podlega obowiązkowi ubezpieczeń społecznych oraz zdrowotnych. Decyzja o dobrowolnym ubezpieczeniu należy do przedsiębiorcy."
	}, {
	    elementQuestion: "7. Co z polityką rachunkowości oraz planem kont?",
	    elementAnswer: "Dla Państwa wygody przygotowany został uniwersalny plan kont oraz polityka rachunkowości, które są generowane automatycznie przez aplikację. Dokumenty te wystarczy wydrukować i podpisać."
	}];

/***/ }),

/***/ 323:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	function getMonthlyPackagePricing(monthlyPackageSelected, quarterlyPackageSelected, halfyearlyPackageSelected, yearlyPackageSelected) {
	    // DANE UNIWERSALNE
	    var packagePriceMonthly = '0.0';
	    var newPricingEnabled = isNewPricingEnabled();
	    // ZWRACANIE DANYCH
	    if (monthlyPackageSelected) {
	        if (newPricingEnabled) {
	            packagePriceMonthly = monthly_price.toFixed(2);
	        } else {
	            packagePriceMonthly = __old_monthly_price.toFixed(2);
	        }
	    } else if (quarterlyPackageSelected) {
	        if (newPricingEnabled) {
	            packagePriceMonthly = (quarterly_price / 3).toFixed(2);
	        } else {
	            packagePriceMonthly = (__old_quarterly_price / 3).toFixed(2);
	        }
	    } else if (halfyearlyPackageSelected) {
	        if (newPricingEnabled) {
	            packagePriceMonthly = (halfyearly_price / 6).toFixed(2);
	        } else {
	            packagePriceMonthly = (__old_halfyearly_price / 6).toFixed(2);
	        }
	    } else if (yearlyPackageSelected) {
	        if (newPricingEnabled) {
	            packagePriceMonthly = (yearly_price / 12).toFixed(2);
	        } else {
	            packagePriceMonthly = (__old_yearly_price / 12).toFixed(2);
	        }
	    } else {}
	    // ZWRACANIE DANYCH
	    return packagePriceMonthly;
	}
	exports.getMonthlyPackagePricing = getMonthlyPackagePricing;
	// INFORMACJA CZY OBOWIĄZUJE NOWY CENNIK
	function isNewPricingEnabled() {
	    // SPRAWDZANIE CZY TO JUŻ PORA NA NOWY CENNIK
	    var oldPricingDate = new Date(2024, 0, 1, 0, 0, 0);
	    var today = new Date();
	    var isTodayAfterOldPricingDate = today >= oldPricingDate;
	    return isTodayAfterOldPricingDate;
	}
	exports.isNewPricingEnabled = isNewPricingEnabled;
	//
	// CENY NETTO
	//
	var __old_monthly_price = 88.00;
	var monthly_price = 99.00;
	var __old_quarterly_price = 249.00;
	var quarterly_price = 279.00;
	var __old_halfyearly_price = 479.00;
	var halfyearly_price = 539.00;
	var __old_yearly_price = 888.00;
	var yearly_price = 999.00;
	//
	// CENY PAKIETÓW
	//
	function getMonthlyPackagePrice() {
	    return isNewPricingEnabled() ? monthly_price : __old_monthly_price;
	}
	exports.getMonthlyPackagePrice = getMonthlyPackagePrice;
	function getQuarterlyPackagePrice() {
	    return isNewPricingEnabled() ? quarterly_price : __old_quarterly_price;
	}
	exports.getQuarterlyPackagePrice = getQuarterlyPackagePrice;
	function getHalfyearlyPackagePrice() {
	    return isNewPricingEnabled() ? halfyearly_price : __old_halfyearly_price;
	}
	exports.getHalfyearlyPackagePrice = getHalfyearlyPackagePrice;
	function getYearlyPackagePrice() {
	    return isNewPricingEnabled() ? yearly_price : __old_yearly_price;
	}
	exports.getYearlyPackagePrice = getYearlyPackagePrice;
	function getElectronicSettlementPackagePrice(eSettlementQuantity) {
	    return 5 * eSettlementQuantity;
	}
	exports.getElectronicSettlementPackagePrice = getElectronicSettlementPackagePrice;

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background-image: none !important;\n"], ["\n  background-image: none !important;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  line-height: 17.6px !important;\n"], ["\n  line-height: 17.6px !important;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n"], ["\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  margin-top: -20px;\n  padding-top: 0px !important;\n  padding-bottom: 40px !important;\n"], ["\n  margin-top: -20px;\n  padding-top: 0px !important;\n  padding-bottom: 40px !important;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"]);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var googleAnalyticsService = __webpack_require__(9);
	var styled_components_1 = __webpack_require__(2);
	var FaqBlockElement = function FaqBlockElement(props) {
	    var activeElementIndex = props.activeElementIndex,
	        elementIndex = props.elementIndex,
	        selectElement = props.selectElement,
	        elementQuestion = props.elementQuestion,
	        elementAnswer = props.elementAnswer,
	        elementButtonLinkTo = props.elementButtonLinkTo;
	
	    var isActive = activeElementIndex == elementIndex;
	    // SPRAWDZANIE CZY OPIS JEST LISTĄ
	    var elementAnswerIsAList = Array.isArray(elementAnswer);
	    // ZWRACANIE DANYCH
	    return React.createElement("div", { className: "panel panel-default" }, React.createElement(PanelHeadingWrapper, { className: "panel-heading", onClick: function onClick() {
	            return selectElement(elementIndex);
	        } }, React.createElement(PanelTitleWrapper, { className: "panel-title" }, React.createElement("a", null, elementQuestion))), React.createElement("div", { className: "panel-collapse collapse in" }, React.createElement(PanelBodyWrapper, { className: "panel-body" }, !elementAnswerIsAList && elementAnswer, elementAnswerIsAList && elementAnswer.map(function (answerPart, i) {
	        return React.createElement("div", { key: i, className: "answer-part" }, answerPart);
	    }), elementButtonLinkTo && React.createElement("a", { href: elementButtonLinkTo, target: "_blank", className: "btn btn-sm waves-effect waves-light mt-20" }, "Wi\u0119cej"))));
	};
	/** STYLES => FaqBlockElement */
	var PanelHeadingWrapper = styled_components_1.default.div(_templateObject);
	var PanelTitleWrapper = styled_components_1.default.h3(_templateObject2);
	var PanelBodyWrapper = styled_components_1.default.div(_templateObject3);
	
	var FaqBlock = function (_React$Component) {
	    _inherits(FaqBlock, _React$Component);
	
	    function FaqBlock(props) {
	        _classCallCheck(this, FaqBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            activeElementIndex: 1
	        };
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        _this.onFaqQuestionSelect = _this.onFaqQuestionSelect.bind(_this);
	        return _this;
	    }
	
	    FaqBlock.prototype.onComponentView = function onComponentView() {
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    FaqBlock.prototype.onFaqQuestionSelect = function onFaqQuestionSelect(index) {
	        // ZAZNACZANIE I ODZNACZANIE
	        var activeElementIndex = this.state.activeElementIndex;
	
	        if (index == activeElementIndex) {
	            this.setState({ activeElementIndex: 0 });
	        } else {
	            this.setState({ activeElementIndex: index });
	        }
	        // GOOGLE EVENT
	        if (this.props.faqQuestionReadEventType) {
	            googleAnalyticsService.trackEvent(this.props.faqQuestionReadEventType);
	        }
	    };
	
	    FaqBlock.prototype.render = function render() {
	        var _this2 = this;
	
	        var faqQuestions = this.props.faqQuestions;
	        var activeElementIndex = this.state.activeElementIndex;
	
	        return React.createElement("div", { className: "materialize-theme-styles", onMouseEnter: this.onComponentView }, React.createElement(FaqBlockWrapper, { className: "section-padding" }, React.createElement("div", { className: "container" }, React.createElement(FaqBlockElementsWrapper, { className: "row" }, React.createElement("div", { className: "col-lg-9 col-md-12 col-sm-12 col-xs-12" }, React.createElement("div", { className: "panel-group flat-accordion brand-accordion z-depth-1" }, faqQuestions.map(function (faqQuestion, index) {
	            return React.createElement(FaqBlockElement, _extends({ key: index, activeElementIndex: activeElementIndex, elementIndex: index + 1, selectElement: _this2.onFaqQuestionSelect }, faqQuestion));
	        })))))));
	    };
	
	    return FaqBlock;
	}(React.Component);
	/** STYLES => FaqBlock */
	
	
	var FaqBlockWrapper = styled_components_1.default.section(_templateObject4);
	var FaqBlockElementsWrapper = styled_components_1.default.div(_templateObject5);
	exports.default = FaqBlock;

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-around;\n  @media (min-width : 993px) {\n    padding-right: 40px;\n    padding-left: 40px;\n    margin-top: 100px;\n  }\n"], ["\n  display: flex;\n  justify-content: space-around;\n  @media (min-width : 993px) {\n    padding-right: 40px;\n    padding-left: 40px;\n    margin-top: 100px;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  max-width: 1200px;\n  width: 100%;\n  justify-content: space-around;\n    @media (max-width : 993px) {\n      flex-direction: column-reverse;\n      padding-right: 40px;\n      padding-left: 40px;\n    }\n  }\n"], ["\n  display: flex;\n  max-width: 1200px;\n  width: 100%;\n  justify-content: space-around;\n    @media (max-width : 993px) {\n      flex-direction: column-reverse;\n      padding-right: 40px;\n      padding-left: 40px;\n    }\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var pricing_info_package_switch_block_1 = __webpack_require__(343);
	var pricing_info_package_trial_info_1 = __webpack_require__(344);
	var googleAnalyticsService = __webpack_require__(9);
	var styled_components_1 = __webpack_require__(2);
	
	var PricingInfoBlock = function (_React$Component) {
	    _inherits(PricingInfoBlock, _React$Component);
	
	    function PricingInfoBlock(props) {
	        _classCallCheck(this, PricingInfoBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onComponentView = _this.onComponentView.bind(_this);
	        _this.onButtonClick = _this.onButtonClick.bind(_this);
	        _this.onLinkClick = _this.onLinkClick.bind(_this);
	        return _this;
	    }
	
	    PricingInfoBlock.prototype.onComponentView = function onComponentView() {
	        if (this.props.componentViewEventType) {
	            googleAnalyticsService.trackEvent(this.props.componentViewEventType);
	        }
	    };
	
	    PricingInfoBlock.prototype.onButtonClick = function onButtonClick() {
	        if (this.props.buttonClickEventType) {
	            googleAnalyticsService.trackEvent(this.props.buttonClickEventType);
	        }
	    };
	
	    PricingInfoBlock.prototype.onLinkClick = function onLinkClick() {
	        if (this.props.linkClickEventType) {
	            googleAnalyticsService.trackEvent(this.props.linkClickEventType);
	        }
	    };
	
	    PricingInfoBlock.prototype.render = function render() {
	        return React.createElement("div", { onMouseEnter: this.onComponentView }, React.createElement(PricingInfoBlockWrapper, null, React.createElement(PricingInfoPackageWrapper, null, React.createElement(pricing_info_package_switch_block_1.default, { onButtonClick: this.onButtonClick, onLinkClick: this.onLinkClick }), React.createElement(pricing_info_package_trial_info_1.default, null))));
	    };
	
	    return PricingInfoBlock;
	}(React.Component);
	/** STYLES */
	
	
	var PricingInfoBlockWrapper = styled_components_1.default.div(_templateObject);
	var PricingInfoPackageWrapper = styled_components_1.default.div(_templateObject2);
	exports.default = PricingInfoBlock;

/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  flex-basis: 50%;\n  overflow: visible !important;\n"], ["\n  flex-basis: 50%;\n  overflow: visible !important;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: #424242 !important;\n  text-align: center !important;\n  font-weight: bold !important;\n  display: block;\n  font-size: 35px !important;\n"], ["\n  color: #424242 !important;\n  text-align: center !important;\n  font-weight: bold !important;\n  display: block;\n  font-size: 35px !important;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n  text-align: center;\n  p {\n    margin: 0;\n  }\n  a {\n    margin-top: -5px;\n    margin-right: 0 !important;\n    text-transform: none !important;\n    color: #1976d2 !important;\n    text-decoration: underline;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n  text-align: center;\n  p {\n    margin: 0;\n  }\n  a {\n    margin-top: -5px;\n    margin-right: 0 !important;\n    text-transform: none !important;\n    color: #1976d2 !important;\n    text-decoration: underline;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  margin-top: 20px;\n"], ["\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  margin-top: 20px;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  color: #1976d2;\n  font-size: 35px;\n  font-weight: 300;\n  margin-right: 6px;\n"], ["\n  color: #1976d2;\n  font-size: 35px;\n  font-weight: 300;\n  margin-right: 6px;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  color: #4c5a72;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 400;\n  text-transform: uppercase;\n"], ["\n  color: #4c5a72;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 400;\n  text-transform: uppercase;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: 7px;\n  margin-bottom: 0px !important;\n  .btn, .btn-large, .btn-flat {\n    margin-bottom: 5px !important;\n    margin-left: 4px !important;\n    margin-right: 4px !important;\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  margin-top: 7px;\n  margin-bottom: 0px !important;\n  .btn, .btn-large, .btn-flat {\n    margin-bottom: 5px !important;\n    margin-left: 4px !important;\n    margin-right: 4px !important;\n  }\n"]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  color: #FFF !important;\n"], ["\n  color: #FFF !important;\n"]),
	    _templateObject9 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;  \n"], ["\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;  \n"]),
	    _templateObject10 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-evenly;\n  margin-top: 25px;\n  text-align: center;\n  @media (max-width: 600px) {\n    flex-direction: column;\n    justify-content: center;\n    ul {\n      padding-left: 20px !important;\n      width: 200px;\n      margin 0 auto !important;\n    }\n  }\n  ul {\n    color: #4d4d4d;\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 28px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    text-align: left;\n  }\n  i {\n    margin-right: 6px;\n  }\n  div.col-sm-6 {\n    display: flex;\n    justify-content: center;\n  }\n"], ["\n  display: flex;\n  justify-content: space-evenly;\n  margin-top: 25px;\n  text-align: center;\n  @media (max-width: 600px) {\n    flex-direction: column;\n    justify-content: center;\n    ul {\n      padding-left: 20px !important;\n      width: 200px;\n      margin 0 auto !important;\n    }\n  }\n  ul {\n    color: #4d4d4d;\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 28px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    text-align: left;\n  }\n  i {\n    margin-right: 6px;\n  }\n  div.col-sm-6 {\n    display: flex;\n    justify-content: center;\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var gatsby_link_1 = __webpack_require__(36);
	var staticUrls = __webpack_require__(17);
	var pricingData = __webpack_require__(323);
	var styled_components_1 = __webpack_require__(2);
	
	var PricingInfoPackageSwitchBlock = function (_React$Component) {
	    _inherits(PricingInfoPackageSwitchBlock, _React$Component);
	
	    function PricingInfoPackageSwitchBlock(props) {
	        _classCallCheck(this, PricingInfoPackageSwitchBlock);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            monthlyPackageSelected: true,
	            quarterlyPackageSelected: false,
	            halfyearlyPackageSelected: false,
	            yearlyPackageSelected: false,
	            packagePrice: pricingData.getMonthlyPackagePricing(true, false, false, false)
	        };
	        _this.selectMonthlyPackage = _this.selectMonthlyPackage.bind(_this);
	        _this.selectQuarterlyPackage = _this.selectQuarterlyPackage.bind(_this);
	        _this.selectHalfyearlyPackage = _this.selectHalfyearlyPackage.bind(_this);
	        _this.selectYearlyPackage = _this.selectYearlyPackage.bind(_this);
	        return _this;
	    }
	
	    PricingInfoPackageSwitchBlock.prototype.selectMonthlyPackage = function selectMonthlyPackage(event) {
	        this.setState({
	            monthlyPackageSelected: true,
	            quarterlyPackageSelected: false,
	            halfyearlyPackageSelected: false,
	            yearlyPackageSelected: false,
	            packagePrice: pricingData.getMonthlyPackagePricing(true, false, false, false)
	        });
	    };
	
	    PricingInfoPackageSwitchBlock.prototype.selectQuarterlyPackage = function selectQuarterlyPackage(event) {
	        this.setState({
	            monthlyPackageSelected: false,
	            quarterlyPackageSelected: true,
	            halfyearlyPackageSelected: false,
	            yearlyPackageSelected: false,
	            packagePrice: pricingData.getMonthlyPackagePricing(false, true, false, false)
	        });
	    };
	
	    PricingInfoPackageSwitchBlock.prototype.selectHalfyearlyPackage = function selectHalfyearlyPackage(event) {
	        this.setState({
	            monthlyPackageSelected: false,
	            quarterlyPackageSelected: false,
	            halfyearlyPackageSelected: true,
	            yearlyPackageSelected: false,
	            packagePrice: pricingData.getMonthlyPackagePricing(false, false, true, false)
	        });
	    };
	
	    PricingInfoPackageSwitchBlock.prototype.selectYearlyPackage = function selectYearlyPackage(event) {
	        this.setState({
	            monthlyPackageSelected: false,
	            quarterlyPackageSelected: false,
	            halfyearlyPackageSelected: false,
	            yearlyPackageSelected: true,
	            packagePrice: pricingData.getMonthlyPackagePricing(false, false, false, true)
	        });
	    };
	
	    PricingInfoPackageSwitchBlock.prototype.render = function render() {
	        var _props = this.props,
	            onButtonClick = _props.onButtonClick,
	            onLinkClick = _props.onLinkClick;
	        var _state = this.state,
	            monthlyPackageSelected = _state.monthlyPackageSelected,
	            quarterlyPackageSelected = _state.quarterlyPackageSelected,
	            halfyearlyPackageSelected = _state.halfyearlyPackageSelected,
	            yearlyPackageSelected = _state.yearlyPackageSelected,
	            packagePrice = _state.packagePrice;
	        // KLASY DO AKTYWNYCH GUZIKÓW
	
	        var monthlyButtonClass = monthlyPackageSelected ? 'blue' : 'grey';
	        var quarterlyButtonClass = quarterlyPackageSelected ? 'blue' : 'grey';
	        var halfyearlyButtonClass = halfyearlyPackageSelected ? 'blue' : 'grey';
	        var yearlyButtonClass = yearlyPackageSelected ? 'blue' : 'grey';
	        return React.createElement(CardWrapper, { className: "card" }, React.createElement("div", { className: "card-content white-text" }, React.createElement(CardTitleWrapper, { className: "card-title" }, "Pe\u0142na ksi\u0119gowo\u015B\u0107 online"), React.createElement(PackageSelectorContainer, null, React.createElement(PackageSelectorButton, { className: "waves-effect waves-light btn " + monthlyButtonClass, onClick: this.selectMonthlyPackage }, "MIESI\u0118CZNIE"), React.createElement(PackageSelectorButton, { className: "waves-effect waves-light btn " + quarterlyButtonClass, onClick: this.selectQuarterlyPackage }, "KWARTALNIE")), React.createElement(PackageSelectorContainer, null, React.createElement(PackageSelectorButton, { className: "waves-effect waves-light btn " + halfyearlyButtonClass, onClick: this.selectHalfyearlyPackage }, "P\xD3\u0141ROCZNIE"), React.createElement(PackageSelectorButton, { className: "waves-effect waves-light btn " + yearlyButtonClass, onClick: this.selectYearlyPackage }, "ROCZNIE")), React.createElement(PriceInfoContainer, null, React.createElement(PriceValueWrapper, null, packagePrice), React.createElement(PriceInfoWrapper, null, "z\u0142 / m-c")), React.createElement(CallToActionContainer, null, React.createElement(CallToActionButtonWrapper, { className: "waves-effect waves-light btn blue", href: staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL, target: "_blank", onClick: onButtonClick }, "Wypr\xF3buj bezp\u0142atnie")), React.createElement(FeatureListContainer, { className: "features-list" }, React.createElement("div", { className: "col-sm-6 col-xs-12" }, React.createElement("ul", { className: "check-circle-list" }, React.createElement("li", null, React.createElement("i", { className: "fa fa-check-square mr-10" }), " Fakturowanie"), React.createElement("li", null, React.createElement("i", { className: "fa fa-check-square mr-10" }), " CRM"), React.createElement("li", null, React.createElement("i", { className: "fa fa-check-square mr-10" }), " Ksi\u0119gowo\u015B\u0107 online"), React.createElement("li", null, React.createElement("i", { className: "fa fa-check-square mr-10" }), " E-deklaracje, JPK i KSeF"), React.createElement("li", null, React.createElement("i", { className: "fa fa-check-square mr-10" }), " Kasa / Bank"))), React.createElement("div", { className: "col-sm-6 col-xs-12" }, React.createElement("ul", { className: "check-circle-list" }, React.createElement("li", null, React.createElement("i", { className: "fa fa-check-square mr-10" }), " Sprawozdania finansowe"), React.createElement("li", null, React.createElement("i", { className: "fa fa-check-square mr-10" }), " Wzorce dokument\xF3w"), React.createElement("li", null, React.createElement("i", { className: "fa fa-check-square mr-10" }), " Rozliczenia kadrowe"), React.createElement("li", null, React.createElement("i", { className: "fa fa-check-square mr-10" }), " Analizy finansowe"), React.createElement("li", null, React.createElement("i", { className: "fa fa-check-square mr-10" }), " Pomoc ksi\u0119gowego"))))), React.createElement(CardFooterWrapper, { className: "card-action" }, React.createElement("p", null, "Podane ceny s\u0105 cenami netto."), React.createElement(gatsby_link_1.default, { to: staticUrls.FAKTUROMANIA_POROWNANIE_PAKIETOW_PAGE_URL, onClick: onLinkClick }, "Por\xF3wnanie pakiet\xF3w")));
	    };
	
	    return PricingInfoPackageSwitchBlock;
	}(React.Component);
	/** STYLES */
	/** CARD */
	
	
	var CardWrapper = styled_components_1.default.div(_templateObject);
	var CardTitleWrapper = styled_components_1.default.span(_templateObject2);
	var CardFooterWrapper = styled_components_1.default.div(_templateObject3);
	/** PRICING INFO */
	var PriceInfoContainer = styled_components_1.default.div(_templateObject4);
	var PriceValueWrapper = styled_components_1.default.span(_templateObject5);
	var PriceInfoWrapper = styled_components_1.default.span(_templateObject6);
	/** PACKAGE SELECTOR CONTAINER */
	var PackageSelectorContainer = styled_components_1.default.div(_templateObject7);
	var PackageSelectorButton = styled_components_1.default.div(_templateObject8);
	/** CALL TO ACTION */
	var CallToActionContainer = styled_components_1.default.div(_templateObject9);
	var CallToActionButtonWrapper = styled_components_1.default.a(_templateObject8);
	/** FEATURES LIST */
	var FeatureListContainer = styled_components_1.default.div(_templateObject10);
	exports.default = PricingInfoPackageSwitchBlock;

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  @media (min-width : 993px) {\n    margin-top: 100px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-right: 30px;\n    padding-left: 30px;\n  }\n  @media (max-width : 993px) {\n    text-align: center;\n    margin-top: 60px;\n    margin-bottom: 40px;\n  }\n"], ["\n  @media (min-width : 993px) {\n    margin-top: 100px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-right: 30px;\n    padding-left: 30px;\n  }\n  @media (max-width : 993px) {\n    text-align: center;\n    margin-top: 60px;\n    margin-bottom: 40px;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  color: #424242 !important;\n  display: block;\n  font-size: 35px !important;\n  strong {\n    font-weight: bold;\n  }\n"], ["\n  color: #424242 !important;\n  display: block;\n  font-size: 35px !important;\n  strong {\n    font-weight: bold;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  p {\n    color: #4d4d4d;\n    margin: 0;\n    font-weight: 400 !important;\n    font-size: 18px;\n    span {\n      font-weight: bold;\n      color: #1976d2;\n    }\n  }\n"], ["\n  p {\n    color: #4d4d4d;\n    margin: 0;\n    font-weight: 400 !important;\n    font-size: 18px;\n    span {\n      font-weight: bold;\n      color: #1976d2;\n    }\n  }\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var PricingInfoPackageTrialInfo = function PricingInfoPackageTrialInfo(props) {
	  return React.createElement("div", null, React.createElement(PricingInfoPackageTrialInfoContainer, null, React.createElement(FreeTrialInfoTitle, null, React.createElement("strong", null, "1 miesi\u0105c testowy, ", React.createElement("br", null), " bez zobowi\u0105za\u0144!")), React.createElement(FreeTrialInfoDescription, null, React.createElement("p", null, "Twoja ksi\u0119gowo\u015B\u0107 online jeszcze nie by\u0142a tak prosta."), React.createElement("p", null, "Testuj ", React.createElement("span", null, "bezp\u0142atnie przez 1 miesi\u0105c.")))));
	};
	/** STYLES */
	var PricingInfoPackageTrialInfoContainer = styled_components_1.default.div(_templateObject);
	var FreeTrialInfoTitle = styled_components_1.default.h3(_templateObject2);
	var FreeTrialInfoDescription = styled_components_1.default.div(_templateObject3);
	exports.default = PricingInfoPackageTrialInfo;

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_helmet_1 = __webpack_require__(23);
	var breadcrumbs_block_1 = __webpack_require__(42);
	var pricing_info_block_1 = __webpack_require__(342);
	var title_block_1 = __webpack_require__(43);
	var features_box_simple_block_1 = __webpack_require__(99);
	var faq_block_1 = __webpack_require__(75);
	var google_analytics_1 = __webpack_require__(34);
	var types_1 = __webpack_require__(14);
	var featuresData = __webpack_require__(97);
	var faqQuestionsData = __webpack_require__(69);
	var helmetData = __webpack_require__(21);
	var cacheBustingService = __webpack_require__(26);
	
	var CennikPage = function (_React$Component) {
	    _inherits(CennikPage, _React$Component);
	
	    function CennikPage() {
	        _classCallCheck(this, CennikPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    CennikPage.prototype.componentDidMount = function componentDidMount() {
	        cacheBustingService.handleCacheBusting(caches);
	    };
	
	    CennikPage.prototype.render = function render() {
	        return React.createElement("div", null, React.createElement(react_helmet_1.Helmet, _extends({}, helmetData.prepareHelmetData(types_1.PageType.CennikPage))), React.createElement(breadcrumbs_block_1.default, { breadcrumbsElement: {
	                elementName: "CENNIK USŁUG",
	                elementDescription: "PRZYJRZYSTY CENNIK USŁUG"
	            } }), React.createElement(pricing_info_block_1.default, { componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.CennikPageViewedMainPricingBlock, buttonClickEventType: google_analytics_1.GoogleAnalyticsEventType.CennikPageClickedCTAAtMainPricingBlock, linkClickEventType: google_analytics_1.GoogleAnalyticsEventType.CennikPageNavigatedToPackagesComparisonPage }), React.createElement(title_block_1.default, { firstLineBlackStart: "Najważniejsze funkcje", firstLineBlue: "aplikacji", firstLineBlackEnd: "", secondLineText: "Zobacz, co otrzymujesz w ramach pakietu." }), React.createElement(features_box_simple_block_1.default, { features: featuresData.STANDARD_APP_FEATURES, featuresBackground: featuresData.GREY_BACKGROUND_COLOR, componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.CennikPageViewedFeaturesBlock }), React.createElement(title_block_1.default, { firstLineBlackStart: "Najczęściej zadawane ", firstLineBlue: "pytania", firstLineBlackEnd: "", secondLineText: "Zapoznaj się odpowiedziami na najczęściej zadawane pytania" }), React.createElement(faq_block_1.default, { faqQuestions: faqQuestionsData.CENNIK_PAGE_FAQ_QUESTIONS, componentViewEventType: google_analytics_1.GoogleAnalyticsEventType.CennikPageViewedFaqBlock, faqQuestionReadEventType: google_analytics_1.GoogleAnalyticsEventType.CennikPageReadFaqQuestion }));
	    };
	
	    return CennikPage;
	}(React.Component);
	
	exports.default = CennikPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cennik-tsx-3a7a2d9dd45ae3306ce0.js